export default __webpack_public_path__ + "static/media/1-min.a9fe50fd.jpg";